import { useState } from 'react';
import TitleLine from './title-line';
import BettingLine from './betting-line';
import FunctionalButtonsLine from './functional-buttons-line';
import './index.css';
import { useTranslation } from 'react-i18next';

const numberArray = Array.from(new Array(10).keys());

const LotteryBoard = ({ title, seriesNumber, remainTime, prefix }) => {
  const [selected, setSelected] = useState([]);
  const [functionalControlled, setFunctionalControlled] = useState(false);

  const handleNumberButtonClick = () => {
    setFunctionalControlled(false);
  };

  const handleFunctionalButtonClick = func => {
    const result = numberArray.filter(number => func(number));
    setSelected(result);
    setFunctionalControlled(true);
  };

  return (
    <div className="lotteryBoardContainer">
      <TitleLine title={title} seriesNumber={seriesNumber} remainTime={remainTime} />
      <BettingLine prefix={prefix} numberArray={numberArray} selected={selected} onNumberButtonClick={handleNumberButtonClick} />
      <FunctionalButtonsLine functionalControlled={functionalControlled} onButtonClick={handleFunctionalButtonClick} />
    </div>
  );
};

const LotteryBlock = () => {
  const { t } = useTranslation();
  const options = [
    { title: t('LotteryBlock.board_title1'), seriesNumber: 123456, remainTime: '03:24', prefix: t('LotteryBlock.board_prefix1') },
    { title: t('LotteryBlock.board_title2'), seriesNumber: 123456, remainTime: '03:24', prefix: t('LotteryBlock.board_prefix2') },
    { title: t('LotteryBlock.board_title3'), seriesNumber: 123456, remainTime: '03:24', prefix: t('LotteryBlock.board_prefix3') },
  ];
  return (
    <div className="lotteryBlockWrapper">
      {options.map((option, index) => (
        <LotteryBoard key={index} {...option} />
      ))}
    </div>
  );
};

export default LotteryBlock;
